<template>
  <FormWrapper>
    <Parties />
    <Agreement />
    <Violation />
    <ApplicableLaw />
  </FormWrapper>
</template>

<script>
import FormWrapper from "../../../../shared/components/FormWrapper";
import Parties from "./parties/PartiesInput";
import Agreement from "./Agreement";
import Violation from "./Violation";
import ApplicableLaw from "./ApplicableLaw";

export default {
  components: {
    FormWrapper,
    Parties,
    Agreement,
    Violation,
    ApplicableLaw,
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/form/Form.vue